// Backend URLs from .env (REACT_APP_* vars) - required, no fallbacks
const requiredEnvVars = [
  "REACT_APP_API_BASE_URL",
  "REACT_APP_SOCKET_URL",
  "REACT_APP_PAYMENT_URL",
  "REACT_APP_INTERNAL_TOOLS_URL",
  "REACT_APP_STRIPE_PREMIUM_YEARLY_URL",
  "REACT_APP_STRIPE_PREMIUM_MONTHLY_URL",
  "REACT_APP_STRIPE_CREDITS_YEARLY_URL",
  "REACT_APP_STRIPE_CREDITS_MONTHLY_URL",
  "REACT_APP_STRIPE_TRIAL_URL",
  "REACT_APP_STRIPE_TRIAL_YEARLY_URL",
  "REACT_APP_CHROME_WEBSTORE_URL",
  "REACT_APP_OPENROUTER_API_URL",
  "REACT_APP_OPENROUTER_API_KEY",
  "REACT_APP_LINKEDIN_SEARCH_URL",
  "REACT_APP_LINKEDIN_CONNECTION_URL",
  "REACT_APP_LINKEDIN_GROUP_URL",
  "REACT_APP_LINKEDIN_EVENT_URL",
  "REACT_APP_LINKEDIN_PROFILE_BASE_URL",
  "REACT_APP_LINKEDIN_ANALYTICS_URL",
  "REACT_APP_HELP_BASE_URL",
  "REACT_APP_HELP_IMPORT_ARTICLE_URL",
  "REACT_APP_TRIAL_VIDEO_URL",
] as const;
for (const key of requiredEnvVars) {
  if (!process.env[key]) {
    throw new Error(`Missing required env var: ${key}. Add it to your .env file.`);
  }
}

export const BASE_URL = process.env.REACT_APP_API_BASE_URL!;
const RAW_SOCKET_URL = process.env.REACT_APP_SOCKET_URL!;
export const SOCKET_URL = RAW_SOCKET_URL.startsWith("ws://")
  ? RAW_SOCKET_URL.replace("ws://", "http://")
  : RAW_SOCKET_URL.startsWith("wss://")
  ? RAW_SOCKET_URL.replace("wss://", "https://")
  : RAW_SOCKET_URL;

/** Default Socket.IO client options (shared). WebSocket-first avoids QA proxy/lb polling 400 issues; polling remains fallback. */
export const SOCKET_IO_CLIENT_OPTIONS: {
  transports: string[];
  upgrade: boolean;
} = {
  transports: ["websocket", "polling"],
  upgrade: true,
};

export const PAYMENT_URL = process.env.REACT_APP_PAYMENT_URL!;
export const INTERNAL_TOOLS_URL = process.env.REACT_APP_INTERNAL_TOOLS_URL!;

export const STRIPE_PREMIUM_YEARLY_URL = process.env.REACT_APP_STRIPE_PREMIUM_YEARLY_URL!;
export const STRIPE_PREMIUM_MONTHLY_URL = process.env.REACT_APP_STRIPE_PREMIUM_MONTHLY_URL!;
export const STRIPE_CREDITS_YEARLY_URL = process.env.REACT_APP_STRIPE_CREDITS_YEARLY_URL!;
export const STRIPE_CREDITS_MONTHLY_URL = process.env.REACT_APP_STRIPE_CREDITS_MONTHLY_URL!;
export const STRIPE_TRIAL_URL = process.env.REACT_APP_STRIPE_TRIAL_URL!;
export const STRIPE_TRIAL_YEARLY_URL = process.env.REACT_APP_STRIPE_TRIAL_YEARLY_URL!;
export const CHROME_WEBSTORE_URL = process.env.REACT_APP_CHROME_WEBSTORE_URL!;
export const PREMIUM_PLAN_NAME = process.env.REACT_APP_PREMIUM_PLAN_NAME || "Premium Plan";

export const OPENROUTER_API_URL = process.env.REACT_APP_OPENROUTER_API_URL!;
export const OPENROUTER_API_KEY = process.env.REACT_APP_OPENROUTER_API_KEY!;

export const LINKEDIN_URLS = {
  searchUrl: process.env.REACT_APP_LINKEDIN_SEARCH_URL!,
  connectionUrl: process.env.REACT_APP_LINKEDIN_CONNECTION_URL!,
  groupUrl: process.env.REACT_APP_LINKEDIN_GROUP_URL!,
  eventUrl: process.env.REACT_APP_LINKEDIN_EVENT_URL!,
  profileBaseUrl: process.env.REACT_APP_LINKEDIN_PROFILE_BASE_URL!,
  analyticsUrl: process.env.REACT_APP_LINKEDIN_ANALYTICS_URL!,
};
export const ENABLE_LINKEDIN_REGISTRATION_CONVERSION =
  String(process.env.REACT_APP_ENABLE_LINKEDIN_REGISTRATION_CONVERSION || "")
    .trim()
    .toLowerCase() === "true";
export const LINKEDIN_PARTNER_ID = (process.env.REACT_APP_LINKEDIN_PARTNER_ID ?? "").trim();
export const LINKEDIN_REGISTRATION_CONVERSION_ID = (
  process.env.REACT_APP_LINKEDIN_REGISTRATION_CONVERSION_ID || "27363506"
).trim();

export const HELP_URLS = {
  base: process.env.REACT_APP_HELP_BASE_URL!,
  importArticle: process.env.REACT_APP_HELP_IMPORT_ARTICLE_URL!,
};

export const TRIAL_VIDEO_URL = process.env.REACT_APP_TRIAL_VIDEO_URL!;

/** Calendly booking URL (same default as marketing site). Override with REACT_APP_BOOK_DEMO_CALL_URL. */
export const BOOK_DEMO_CALL_URL = (
  process.env.REACT_APP_BOOK_DEMO_CALL_URL || "https://calendly.com/fahad-md-co"
).trim();

export const FREE_TRIAL_FEATURES = [
  "Unlimited campaigns",
  "Unlimited sequences",
  "Unlimited AI personalization",
  "800 invitations per month",
  "200 messages per day",
  "Advanced campaign analytics",
];
